import { render } from "./Contratti.vue?vue&type=template&id=9ec02362&scoped=true"
import script from "./Contratti.vue?vue&type=script&lang=js"
export * from "./Contratti.vue?vue&type=script&lang=js"

import "./Contratti.vue?vue&type=style&index=0&id=9ec02362&scoped=true&lang=css"

import exportComponent from "C:\\Users\\germa\\dev\\dcpower.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ec02362"]])

export default __exports__